export const OPERATIONAL_CONTACT_VALIDATION_RULES = {
    contactEmailAddress: {
        regex: {
            value: {
                pattern: /^$|^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i,
                customMessageKey: "validation.customMessages.emailAddressRegex",
            },
        },
    },
    adminContactEmailAddress: {
        regex: {
            value: {
                pattern: /^$|^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i,
                customMessageKey: "validation.customMessages.emailAddressRegex",
            },
        },
    },
};



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/contacts/operational-contacts/operationalContactsValidationRules.js